/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as DataExportsDataExportsIdImport } from './routes/data-exports/$dataExportsId'
import { Route as WhatsOnTokenIndexImport } from './routes/whats-on/$token/index'
import { Route as PublicTokenIndexImport } from './routes/public/$token/index'
import { Route as WhatsOnTokenSessionsSessionIdImport } from './routes/whats-on/$token/sessions/$sessionId'
import { Route as WhatsOnTokenAppointmentsAppointmentIdImport } from './routes/whats-on/$token/appointments/$appointmentId'

// Create/Update Routes

const DataExportsDataExportsIdRoute = DataExportsDataExportsIdImport.update({
  id: '/data-exports/$dataExportsId',
  path: '/data-exports/$dataExportsId',
  getParentRoute: () => rootRoute,
} as any)

const WhatsOnTokenIndexRoute = WhatsOnTokenIndexImport.update({
  id: '/whats-on/$token/',
  path: '/whats-on/$token/',
  getParentRoute: () => rootRoute,
} as any)

const PublicTokenIndexRoute = PublicTokenIndexImport.update({
  id: '/public/$token/',
  path: '/public/$token/',
  getParentRoute: () => rootRoute,
} as any)

const WhatsOnTokenSessionsSessionIdRoute =
  WhatsOnTokenSessionsSessionIdImport.update({
    id: '/whats-on/$token/sessions/$sessionId',
    path: '/whats-on/$token/sessions/$sessionId',
    getParentRoute: () => rootRoute,
  } as any)

const WhatsOnTokenAppointmentsAppointmentIdRoute =
  WhatsOnTokenAppointmentsAppointmentIdImport.update({
    id: '/whats-on/$token/appointments/$appointmentId',
    path: '/whats-on/$token/appointments/$appointmentId',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/data-exports/$dataExportsId': {
      id: '/data-exports/$dataExportsId'
      path: '/data-exports/$dataExportsId'
      fullPath: '/data-exports/$dataExportsId'
      preLoaderRoute: typeof DataExportsDataExportsIdImport
      parentRoute: typeof rootRoute
    }
    '/public/$token/': {
      id: '/public/$token/'
      path: '/public/$token'
      fullPath: '/public/$token'
      preLoaderRoute: typeof PublicTokenIndexImport
      parentRoute: typeof rootRoute
    }
    '/whats-on/$token/': {
      id: '/whats-on/$token/'
      path: '/whats-on/$token'
      fullPath: '/whats-on/$token'
      preLoaderRoute: typeof WhatsOnTokenIndexImport
      parentRoute: typeof rootRoute
    }
    '/whats-on/$token/appointments/$appointmentId': {
      id: '/whats-on/$token/appointments/$appointmentId'
      path: '/whats-on/$token/appointments/$appointmentId'
      fullPath: '/whats-on/$token/appointments/$appointmentId'
      preLoaderRoute: typeof WhatsOnTokenAppointmentsAppointmentIdImport
      parentRoute: typeof rootRoute
    }
    '/whats-on/$token/sessions/$sessionId': {
      id: '/whats-on/$token/sessions/$sessionId'
      path: '/whats-on/$token/sessions/$sessionId'
      fullPath: '/whats-on/$token/sessions/$sessionId'
      preLoaderRoute: typeof WhatsOnTokenSessionsSessionIdImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/data-exports/$dataExportsId': typeof DataExportsDataExportsIdRoute
  '/public/$token': typeof PublicTokenIndexRoute
  '/whats-on/$token': typeof WhatsOnTokenIndexRoute
  '/whats-on/$token/appointments/$appointmentId': typeof WhatsOnTokenAppointmentsAppointmentIdRoute
  '/whats-on/$token/sessions/$sessionId': typeof WhatsOnTokenSessionsSessionIdRoute
}

export interface FileRoutesByTo {
  '/data-exports/$dataExportsId': typeof DataExportsDataExportsIdRoute
  '/public/$token': typeof PublicTokenIndexRoute
  '/whats-on/$token': typeof WhatsOnTokenIndexRoute
  '/whats-on/$token/appointments/$appointmentId': typeof WhatsOnTokenAppointmentsAppointmentIdRoute
  '/whats-on/$token/sessions/$sessionId': typeof WhatsOnTokenSessionsSessionIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/data-exports/$dataExportsId': typeof DataExportsDataExportsIdRoute
  '/public/$token/': typeof PublicTokenIndexRoute
  '/whats-on/$token/': typeof WhatsOnTokenIndexRoute
  '/whats-on/$token/appointments/$appointmentId': typeof WhatsOnTokenAppointmentsAppointmentIdRoute
  '/whats-on/$token/sessions/$sessionId': typeof WhatsOnTokenSessionsSessionIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/data-exports/$dataExportsId'
    | '/public/$token'
    | '/whats-on/$token'
    | '/whats-on/$token/appointments/$appointmentId'
    | '/whats-on/$token/sessions/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/data-exports/$dataExportsId'
    | '/public/$token'
    | '/whats-on/$token'
    | '/whats-on/$token/appointments/$appointmentId'
    | '/whats-on/$token/sessions/$sessionId'
  id:
    | '__root__'
    | '/data-exports/$dataExportsId'
    | '/public/$token/'
    | '/whats-on/$token/'
    | '/whats-on/$token/appointments/$appointmentId'
    | '/whats-on/$token/sessions/$sessionId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  DataExportsDataExportsIdRoute: typeof DataExportsDataExportsIdRoute
  PublicTokenIndexRoute: typeof PublicTokenIndexRoute
  WhatsOnTokenIndexRoute: typeof WhatsOnTokenIndexRoute
  WhatsOnTokenAppointmentsAppointmentIdRoute: typeof WhatsOnTokenAppointmentsAppointmentIdRoute
  WhatsOnTokenSessionsSessionIdRoute: typeof WhatsOnTokenSessionsSessionIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  DataExportsDataExportsIdRoute: DataExportsDataExportsIdRoute,
  PublicTokenIndexRoute: PublicTokenIndexRoute,
  WhatsOnTokenIndexRoute: WhatsOnTokenIndexRoute,
  WhatsOnTokenAppointmentsAppointmentIdRoute:
    WhatsOnTokenAppointmentsAppointmentIdRoute,
  WhatsOnTokenSessionsSessionIdRoute: WhatsOnTokenSessionsSessionIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/data-exports/$dataExportsId",
        "/public/$token/",
        "/whats-on/$token/",
        "/whats-on/$token/appointments/$appointmentId",
        "/whats-on/$token/sessions/$sessionId"
      ]
    },
    "/data-exports/$dataExportsId": {
      "filePath": "data-exports/$dataExportsId.tsx"
    },
    "/public/$token/": {
      "filePath": "public/$token/index.tsx"
    },
    "/whats-on/$token/": {
      "filePath": "whats-on/$token/index.tsx"
    },
    "/whats-on/$token/appointments/$appointmentId": {
      "filePath": "whats-on/$token/appointments/$appointmentId.tsx"
    },
    "/whats-on/$token/sessions/$sessionId": {
      "filePath": "whats-on/$token/sessions/$sessionId.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
